import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';

import { App } from './App';
import { AtualizacaoDisponivel } from './components/pwa/atualizacao-disponivel';
import { ProvedorAuth } from './features/auth/auth-context';
import { ErroApi } from './lib/api';
import { INTERVALO_ATUALIZACAO_MS } from './lib/consultas';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Alinhado ao intervalo de atualização automática: nada é considerado
      // fresco por mais tempo do que o ciclo de polling.
      staleTime: INTERVALO_ATUALIZACAO_MS,
      // Ligado de propósito. O KAVI é multiusuário: voltar para a aba depois
      // de atender alguém no balcão deve mostrar o estado atual, não o de
      // quando a aba foi deixada. Consultas com dados estáveis (catálogos)
      // sobrescrevem o staleTime localmente e não são afetadas.
      refetchOnWindowFocus: true,
      retry: (tentativas, erro) => {
        // Erro de permissão ou de validação não melhora com nova tentativa.
        if (erro instanceof ErroApi && erro.status >= 400 && erro.status < 500) {
          return false;
        }
        return tentativas < 2;
      },
    },
    mutations: { retry: false },
  },
});

const raiz = document.getElementById('root');
if (!raiz) {
  throw new Error('Elemento #root não encontrado no index.html');
}

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* O provedor precisa ficar dentro do Router: ele navega ao expirar a
            sessão. E dentro do QueryClientProvider: limpa o cache ao sair. */}
        <ProvedorAuth>
          <App />
          <AtualizacaoDisponivel />
          <Toaster position="top-right" richColors closeButton />
        </ProvedorAuth>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
